<template>
  <div>
    <div style="margin-bottom: 20px;">
      <el-popover
        v-model="isExportSelectedPopoverVisible"
        placement="top"
        width="260"
      >
        <p>Add meg a bizonylatszámot</p>
        <el-input v-model="receiptNumber" size="mini" style="margin-bottom: 20px;"></el-input>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="isExportSelectedPopoverVisible = false">
            Mégsem
          </el-button>
          <el-button type="primary" :disabled="!receiptNumber" size="mini"
                     :loading="exportSelectedLoading" @click="exportSelected">Exportálás
          </el-button>
        </div>
        <el-button style="margin-right: 5px;" slot="reference"
                   :disabled="selectedInvoices.length === 0" size="small" icon="el-icon-download">
          Kijelöltek exportálása (.csv)
        </el-button>
      </el-popover>
      <el-popover
        v-model="isExportAllPopoverVisible"
        placement="top"
        width="260"
      >
        <p>Add meg a bizonylatszámot</p>
        <el-input v-model="receiptNumber" size="mini" style="margin-bottom: 20px;"></el-input>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="isExportAllPopoverVisible = false">Mégsem
          </el-button>
          <el-button type="primary" :disabled="!receiptNumber" size="mini"
                     :loading="exportAllLoading" @click="exportAll">Exportálás
          </el-button>
        </div>
        <el-button style="margin-right: 5px;" slot="reference" size="small" icon="el-icon-download">
          Összes számla exportálása (.csv)
        </el-button>
      </el-popover>
      <el-popover
        v-model="isExportNotExportedPopoverVisible"
        placement="top"
        width="260"
      >
        <p>Add meg a bizonylatszámot</p>
        <el-input v-model="receiptNumber" size="mini" style="margin-bottom: 20px;"></el-input>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="isExportNotExportedPopoverVisible = false">
            Mégsem
          </el-button>
          <el-button type="primary" :disabled="!receiptNumber" size="mini"
                     :loading="exportNotExportedLoading" @click="exportNotExported">Exportálás
          </el-button>
        </div>
        <el-button style="margin-right: 5px;" slot="reference" size="small" icon="el-icon-download">
          Nem exportált számlák exportálása (.csv)
        </el-button>
      </el-popover>
      <el-button :disabled="selectedInvoices.length === 0" :loading="removeMarkLoading" size="small"
                 icon="el-icon-refresh-right" @click="removeExportMark">Kijelöltek export
        jelölésének megszüntetése
      </el-button>
    </div>
    <div
      v-loading="loading"
    >
      <el-table
        :data="invoices.data"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="getRowIsValid"
        />
        <el-table-column
          prop="invoice_number"
          label="Exportált"
          width="100"
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.ntax_exported"
              size="small"
              type="success"
            >
              Igen
            </el-tag>
            <el-tag
              v-if="!scope.row.ntax_exported"
              size="small"
              type="danger"
            >
              Nem
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="invoice_number"
          label="Számlaszám"
          width="150"
        >
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.invoice_file"
              type="primary"
              @click="openInvoice(scope.row)"
            >
              <i class="el-icon-printer"></i> {{ scope.row.invoice_number }}
            </el-link>
            <div
              v-else
            >
              {{ scope.row.invoice_number }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="Típus"
          width="90"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 'CREATE'" size="small" type="success">Normál</el-tag>
            <el-tag v-if="scope.row.type === 'STORNO'" size="small" type="danger">Sztornó</el-tag>
            <el-tag v-if="scope.row.type === 'MODIFY'" size="small" type="warning">Módosító</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="delivery_date"
          label="Teljesítés"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.delivery_date | date }}
          </template>
        </el-table-column>
        <el-table-column
          prop="payment_method"
          label="Fizetési mód"
          width="130"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.payment_method === 'CASH'" size="small" type="success">
              <i class="el-icon-coin"></i> Készpénz
            </el-tag>
            <el-tag v-if="scope.row.payment_method === 'TRANSFER'" size="small" type="primary">
              <i class="el-icon-bank-card"></i> Átutalás
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="customer_name"
          label="Vevő"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            #{{ scope.row.customer.id }} {{ scope.row.customer_name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="is_valid"
          label="Státusz"
          min-width="200"
        >
          <template slot-scope="scope">
            <el-tag
              v-if="getRowIsValid(scope.row)"
              size="small"
              type="success"
              effect="dark"
              style="cursor: pointer;"
              @click="fixInvoiceData(scope.row)"
            >
              <i class="el-icon-circle-check"></i> Minden adat helyesen megadva
            </el-tag>
            <el-tag
              v-if="!getRowIsValid(scope.row)"
              size="small"
              type="danger"
              effect="dark"
              style="cursor: pointer;"
              @click="fixInvoiceData(scope.row)"
            >
              <i class="el-icon-circle-close"></i> Adatkorrekció szükséges
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="Adatkorrekció"
        :visible.sync="displayDialog"
        width="800px"
      >
        <el-form
          :model="selectedRow"
          ref="dataCorrection"
          :rules="rules"
        >
          <el-row :gutter="20">
            <el-col :span="16">
              <p><strong>Vevő név</strong></p>
              <p>{{ selectedRow.customer_name }}</p>
            </el-col>
            <el-col :span="8">
              <el-form-item
                prop="customer.ntax_partner.ntax_code"
                label="Vevő NTAX kód"
              >
                <el-input
                  v-model="selectedRow.customer.ntax_partner.ntax_code"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <p><strong>Cím</strong></p>
              <p>{{ selectedRow.customer_postal_code }} {{ selectedRow.customer_city }} {{ selectedRow.customer_address }}</p>
            </el-col>
            <el-col :span="6">
              <p><strong>Adószám</strong></p>
              <p>{{ selectedRow.customer.tax_number }}</p>
            </el-col>
            <el-col :span="6">
              <p><strong>Csoportos adószám</strong></p>
              <p>{{ selectedRow.customer.group_tax_number }}</p>
            </el-col>
          </el-row>
          <el-table
            :data="selectedSuppliers"
          >
            <el-table-column
              prop="company.name"
              label="Beszállító"
              min-width="150"
              show-overflow-tooltip
            />
            <el-table-column
              prop="ntax_partner.job_number"
              label="Munkaszám"
              min-width="100"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.ntax_partner.job_number"
                  size="mini"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="ntax_partner.cost_centre"
              label="Költséghely"
              min-width="100"
            >
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.ntax_partner.cost_centre"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="ntax_partner.supplier_ntax_code"
              label="NTAX kód"
              min-width="100"
            >
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.ntax_partner.supplier_ntax_code"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="ntax_partner.web_ntax_code"
              label="WEB NTAX kód"
              min-width="100"
            >
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.ntax_partner.web_ntax_code"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="displayDialog = false">
            Mégse
          </el-button>
          <el-button
            type="primary"
            :loading="saveButtonLoading"
            @click="saveCorrection"
          >
            Mentés
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';

export default {
  data() {
    return {
      saveButtonLoading: false,
      receiptNumber: '',
      isExportSelectedPopoverVisible: false,
      isExportAllPopoverVisible: false,
      isExportNotExportedPopoverVisible: false,
      exportSelectedLoading: false,
      exportAllLoading: false,
      exportNotExportedLoading: false,
      removeMarkLoading: false,
      selectedInvoices: [],
      selectedSuppliers: [],
      rules: {
        'customer.ntax_partner.ntax_code': [
          {
            required: true,
            message: 'Mező megadása kötelező',
            trigger: 'change'
          }
        ],
      },
      selectedRow: {
        customer: {
          ntax_partner: {},
        },
      },
      displayDialog: false,
    };
  },
  computed: {
    invoices() {
      return this.$store.getters['invoice/rawInvoices'];
    },
    loading() {
      return this.$store.getters['invoice/loading'];
    },
  },
  async mounted() {
    if (this.$route.query && Object.keys(this.$route.query).length !== 0) {
      const queryString = Object.keys(this.$route.query)
        .map((key) => key + '=' + this.$route.query[key])
        .join('&');
      await this.$store.dispatch('invoice/fetchAllRaw', '?' + queryString);
    } else {
      await this.$store.dispatch('invoice/fetchAllRaw');
    }
  },
  methods: {
    async saveCorrection() {
      this.$refs.dataCorrection.validate(async valid => {
        let suppliersAreValid = true;
        this.selectedSuppliers.forEach(supplier => {
          if (supplier && (!supplier.ntax_partner.supplier_ntax_code || !supplier.ntax_partner.job_number || !supplier.ntax_partner.cost_centre)) {
            suppliersAreValid = false;
          }
        });
        if (!suppliersAreValid) {
          this.$messageWrapper.warning('Beszállító(k) adatai rosszul van kitöltve.');
          return;
        }
        if (valid) {
          this.saveButtonLoading = true;
          try {
            await axios.put('api/ntax-partners/correction', {
              row: this.selectedRow,
              suppliers: this.selectedSuppliers
            });
          } catch (e) {
          }
          this.displayDialog = false;
          this.saveButtonLoading = false;
          if (this.$route.query && Object.keys(this.$route.query).length !== 0) {
            const queryString = Object.keys(this.$route.query)
              .map((key) => key + '=' + this.$route.query[key])
              .join('&');
            this.$store.dispatch('invoice/fetchAllRaw', '?' + queryString);
          } else {
            this.$store.dispatch('invoice/fetchAllRaw');
          }
        }
      });
    },
    fixInvoiceData(row) {
      this.selectedSuppliers = [];
      this.selectedRow = JSON.parse(JSON.stringify(row));
      if (!this.selectedRow.customer.ntax_partner) {
        this.selectedRow.customer.ntax_partner = {
          ntax_code: '',
          supplier_ntax_code: '',
          job_number: '',
          cost_centre: '',
          store_in_txt: null,
        };
      }
      this.selectedRow.invoice_items.forEach(item => {
        if (!this.selectedSuppliers.find(supp => supp && supp.id && item.supplier && supp.id === item.supplier.id)) {
          if (item.supplier && !item.supplier.ntax_partner) {
            item.supplier.ntax_partner = {
              ntax_code: '',
              supplier_ntax_code: '',
              job_number: '',
              cost_centre: '',
              store_in_txt: null,
            };
          }
          if (!this.selectedSuppliers.find(s => s && s.id && item.supplier && s.id === item.supplier.id)) {
            this.selectedSuppliers.push(item.supplier);
          }
        }
      });
      this.displayDialog = true;
    },
    getRowIsValid(row) {
      let isValid = true;
      if (!row.customer || !row.customer.ntax_partner || (row.customer && row.customer.ntax_partner && !row.customer.ntax_partner.ntax_code)) {
        return false;
      }
      row.invoice_items.forEach(item => {
        if (!item.supplier) {
          // isValid = false;
        }
        if (item.supplier && !item.supplier.ntax_partner) {
          isValid = false;
        }
        if (item.supplier && item.supplier.ntax_partner && (!item.supplier.ntax_partner.supplier_ntax_code || !item.supplier.ntax_partner.web_ntax_code || !item.supplier.ntax_partner.job_number || !item.supplier.ntax_partner.cost_centre)) {
          isValid = false;
        }
      });
      return isValid;
    },
    handleSelectionChange(invoices) {
      this.selectedInvoices = invoices.map(invoice => invoice.id);
    },
    openInvoice(row) {
      window.open(row.invoice_file.path);
    },
    handleAction(action) {
      action();
    },
    async exportSelected() {
      this.exportSelectedLoading = true;
      try {
        const invoices = await axios({
          url: 'api/ntax-partners/download-invoice',
          method: 'POST',
          data: {
            receiptNumber: this.receiptNumber,
            invoiceIds: this.selectedInvoices,
          },
        });
        console.log(invoices)
        saveAs('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + btoa(invoices), `SZAMLA.csv`);
        await this.$store.dispatch('invoice/fetchAllRaw');
      } catch (e) {
        console.log(e);
      }
      this.exportSelectedLoading = false;
      this.isExportSelectedPopoverVisible = false;
    },
    async exportAll() {
      this.exportAllLoading = true;
      try {
        const invoices = await axios({
          url: 'api/ntax-partners/download-invoice',
          method: 'POST',
          data: {
            receiptNumber: this.receiptNumber,
          },
        });
        saveAs('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + btoa(invoices), `SZAMLA.csv`);
        await this.$store.dispatch('invoice/fetchAllRaw');
      } catch (e) {
        console.log(e);
      }
      this.exportAllLoading = false;
      this.isExportAllPopoverVisible = false;
    },
    async exportNotExported() {
      this.exportNotExportedLoading = true;
      try {
        const invoices = await axios({
          url: 'api/ntax-partners/download-invoice',
          method: 'POST',
          data: {
            receiptNumber: this.receiptNumber,
            notExported: true,
          },
        });
        saveAs('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + btoa(invoices), `SZAMLA.csv`);
        await this.$store.dispatch('invoice/fetchAllRaw');
      } catch (e) {
        console.log(e);
      }
      this.exportNotExportedLoading = false;
      this.isExportNotExportedPopoverVisible = false;
    },
    async removeExportMark() {
      this.removeMarkLoading = true;
      try {
        await axios({
          url: 'api/ntax-partners/remove-export-mark',
          method: 'POST',
          data: {
            invoiceIds: this.selectedInvoices,
          },
        });
        this.$store.dispatch('invoice/fetchAllRaw');
      } catch (e) {
        console.log(e);
      }
      this.removeMarkLoading = false;
    },
  },
};
</script>
